import { useQuery } from '@tanstack/react-query'
import { pb } from '@/lib/pocketbase'
import type { Attachment, OcrResult } from '@/lib/pocketbase'

// Fetch attachments for a tender
export function useTenderAttachments(tenderId: string) {
  return useQuery({
    queryKey: ['tender-attachments', tenderId],
    queryFn: async () => {
      const result = await pb.collection('attachments').getList<Attachment>(1, 100, {
        filter: `tender = "${tenderId}"`,
        sort: '-published_at',
      })
      return result.items.map((item) => ({
        ...item,
        tender_id: (item as any).tender,
        expand: { ...(item as any).expand, tender_id: (item as any).expand?.tender },
      }))
    },
    enabled: !!tenderId,
  })
}

// Fetch OCR result for an attachment
export function useOcrResult(attachmentId: string) {
  return useQuery({
    queryKey: ['ocr-result', attachmentId],
    queryFn: async () => {
      const result = await pb.collection('ocr_results').getFirstListItem<OcrResult>(
        `attachment = "${attachmentId}"`
      )
      return {
        ...result,
        attachment_id: (result as any).attachment,
        expand: { ...result.expand, attachment_id: (result.expand as any)?.attachment },
      }
    },
    enabled: !!attachmentId,
  })
}

// Get attachment download URL
export function getAttachmentUrl(attachment: Attachment): string {
  return pb.files.getUrl(attachment, attachment.file)
}
